// extracted by mini-css-extract-plugin
module.exports = {"mail":"Newsletter_mail__1S3BZ","button":"Newsletter_button__1vtcQ"};